import { useMemo } from "react";
import ReactApexChart from "react-apexcharts";

const VehicleCategoryDistributionChart = ({ data }) => {
  const categories = Array.isArray(data?.categories) ? data.categories : [];

  const labels = useMemo(
    () => categories.map((item) => item?.category || "Unknown"),
    [categories]
  );

  const series = useMemo(
    () => categories.map((item) => Number(item?.count) || 0),
    [categories]
  );

  const options = useMemo(
    () => ({
      chart: {
        type: "pie",
        fontFamily: "inherit",
        toolbar: {
          show: false,
        },
      },
      labels,
      legend: {
        position: "bottom",
      },
      dataLabels: {
        enabled: true,
        formatter: (val) => `${val.toFixed(0)}%`,
      },
      stroke: {
        colors: ["#fff"],
      },
      colors: ["#2F80ED", "#27AE60", "#F2994A", "#EB5757", "#9B51E0", "#56CCF2"],
      tooltip: {
        y: {
          formatter: (value) => `${value} vehicles`,
        },
      },
      noData: {
        text: "No vehicle category distribution data available",
      },
      responsive: [
        {
          breakpoint: 768,
          options: {
            chart: {
              width: "100%",
            },
          },
        },
      ],
    }),
    [labels]
  );

  return (
    <div className="card">
      <div className="card-header d-flex justify-content-between align-items-center">
        <h4 className="card-title mb-0">Vehicle Category Distribution</h4>
        <span className="badge badge-primary">Total: {Number(data?.totalVehicles) || 0}</span>
      </div>
      <div className="card-body">
        <div className="line-chart-style bar-chart d-flex justify-content-center">
          <ReactApexChart options={options} series={series} type="pie" height={380} />
        </div>
      </div>
    </div>
  );
};

export default VehicleCategoryDistributionChart;
